import React, {Component} from 'react';
import { connect } from 'react-redux';

class CheckEmail extends Component {
  render() {
    const {signForm} = this.props;
    return (
      <div className="row signup-box">
        <div className="col-md-8 col-md-offset-2">
          <div className="sing-box text-center">
            <div className="email-box">
              <h1>Check your Email to Submit Your Business to Rifird</h1>
              <h3>
                To submit your business for addition to Rifird, please click on the confirmation
                Link in the email that was sent to <span className="bold">{signForm.email}</span>
              </h3>
            </div>
            <a href="/#/" className="btn btn-default">Go to main page</a>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    currentStep: state.currentStep,
    signForm: state.forms.signForm,
  })
)(CheckEmail);


/** WEBPACK FOOTER **
 ** ./src/components/Sign/check_email.js
 **/